import { getWindowSize } from '../../utils/helpers';
import { updateLinksAttributes } from '../../utils/handleAttributes';

export default function eventCards() {
  const widgetName = 'eventCards';
  const widgetOpts = eventCardsOpts;

  const isDesktop = getWindowSize(800);

  const wrapContainerClass = 'eventCards-container-wrapper';
  const $widget = $(`#${widgetName}`);

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return new Promise((resolve) => {
    return saffire.widgets.cardWidget($($widget), {
      currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
      scriptPath: widgetOpts.scriptPath,
      link: isDesktop ? [] : ['all'],
      showDescription: true,
      moreButton: true,
      hasImages: true,
      lazyLoadImages: true,
      imageIsBackground: true,
      textOverImage: true,
      maxItemsVisible: 4,
      itemsPerPanel: 1,
      buyNowButton: false,

      cardWidgetLoaded: function (data, _owl, hasData) {
        if (hasData) {
          createCustomCards(data.items, $widget, isDesktop);
          resolve(true);
        } else {
          $(`.${wrapContainerClass}`).remove();
          resolve(false);
        }
      },
    });
  });
}

function createCustomCards(widgetData, $widget, isDesktop) {
  $widget.find('.card-content').remove();

  $widget.find('.card-widget-item').each(function (x) {
    const { Title, URL } = widgetData[x];
    const $cardItem = $(this);
    const customButton = createButton(URL, Title);

    $cardItem.append(`
          <div class="card-content">
            <div class="widget-title-wrapper">
              <span class="widget-title">
                ${Title}</span>
              </div>
            <div class="hover-content"></div>
          </div>`);

    $cardItem.find('.hover-content').append(customButton);
    updateCardsMobile(isDesktop, $cardItem, URL, Title);
    validateUrl(URL, $cardItem);
  });
}

function validateUrl(url, $cardItem) {
  if ($cardItem && url === null) {
    $cardItem.addClass('void-url');
  }
  return url !== null;
}

function createButton(url, title) {
  let customButton = '';

  if (validateUrl(url)) {
    const label = `More about ${title}`;
    const attrs = updateLinksAttributes(url, label);
    const link = '<a href="' + url + '" ' + attrs + ' class="button" role="button">More</a>';
    customButton = '<div class="widget-button-wrapper">' + link + '</div>';
  }
  return customButton;
}

function updateCardsMobile(isDesktop, $cardItem, URL, Title) {
  if (isDesktop) {
    return;
  } else {
    updateLinksAttributes(URL, Title, $cardItem);
  }
}
